import type { FC } from "react";

interface InfoBlockProps {
  label: string;
  value: string;
}

const InfoBlock: FC<InfoBlockProps> = ({ label, value }) => {
  return (
    <div>
      <p className="text-white text-xs font-light">{label}</p>
      <p className="text-white text-xs font-bold">{value}</p>
    </div>
  );
};
export default InfoBlock;
